import { useEffect, useState } from 'react';
import axios from 'axios';
import baseUrl from '../../../helpers/baseUrl';

function ExtraSection() {
    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [extraSectionInfo, setExtraSectionInfo] = useState(null);

    // State for each section
    const [categoryType1, setCategoryType1] = useState('');
    const [categoryName1, setCategoryName1] = useState('');
    const [categoryType2, setCategoryType2] = useState('');
    const [categoryName2, setCategoryName2] = useState('');
    const [categoryType3, setCategoryType3] = useState('');
    const [categoryName3, setCategoryName3] = useState('');
    const [categoryType4, setCategoryType4] = useState('');
    const [categoryName4, setCategoryName4] = useState('');
    const [categoryType5, setCategoryType5] = useState('');
    const [categoryName5, setCategoryName5] = useState('');
    const [categoryType6, setCategoryType6] = useState('');
    const [categoryName6, setCategoryName6] = useState('');
    const [categoryType7, setCategoryType7] = useState('');
    const [categoryName7, setCategoryName7] = useState('');


    useEffect(() => {
        const fetchExtraSectionInfo = async () => {
            try {
                const response = await axios.get(`${baseUrl}/api/extra-section`);
                setExtraSectionInfo(response.data);
                console.log('res', response.data);

                setCategoryType1(response.data.type1);
                setCategoryName1(response.data.name1);
                setCategoryType2(response.data.type2);
                setCategoryName2(response.data.name2);
                setCategoryType3(response.data.type3);
                setCategoryName3(response.data.name3);
                setCategoryType4(response.data.type4);
                setCategoryName4(response.data.name4);
                setCategoryType5(response.data.type5);
                setCategoryName5(response.data.name5);
                setCategoryType6(response.data.type6);
                setCategoryName6(response.data.name6);
                setCategoryType7(response.data.type7);
                setCategoryName7(response.data.name7);
            } catch (error) {
                console.error("Error fetching extra section info:", error);
            }
        };
        fetchExtraSectionInfo();
    }, []);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await axios.get(`${baseUrl}/api/categories/categories`);
                setCategories(response.data);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };
        fetchCategories();
    }, []);

    useEffect(() => {
        const fetchSubcategories = async () => {
            try {
                const response = await axios.get(`${baseUrl}/api/categories/subcategories`);
                setSubcategories(response.data);
            } catch (error) {
                console.error("Error fetching subcategories:", error);
            }
        };
        fetchSubcategories();
    }, []);

    const handleCategoryTypeChange = async (event, section) => {
        const selectedType = event.target.value;
        if (section === 1) setCategoryType1(selectedType);
        if (section === 2) setCategoryType2(selectedType);
        if (section === 3) setCategoryType3(selectedType);
        if (section === 4) setCategoryType4(selectedType);
        if (section === 5) setCategoryType5(selectedType);
        if (section === 6) setCategoryType6(selectedType);
        if (section === 7) setCategoryType7(selectedType);

        try {
            await axios.put(`${baseUrl}/api/extra-section/${extraSectionInfo._id}`, {
                [`type${section}`]: selectedType,
            });
        } catch (error) {
            console.error("Error updating category type:", error);
        }

        if (selectedType === "Category") {
            if (section === 1) setCategoryName1('');
            if (section === 2) setCategoryName2('');
            if (section === 3) setCategoryName3('');
            if (section === 4) setCategoryName4('');
            if (section === 5) setCategoryName5('');
            if (section === 6) setCategoryName6('');
            if (section === 7) setCategoryName7('');
        } else if (selectedType === "Subcategory") {
            if (section === 1) setCategoryName1('');
            if (section === 2) setCategoryName2('');
            if (section === 3) setCategoryName3('');
            if (section === 4) setCategoryName4('');
            if (section === 5) setCategoryName6('');
            if (section === 6) setCategoryName6('');
            if (section === 7) setCategoryName7('');
        }
    };

    const handleCategoryNameChange = async (event, section) => {
        const [selectedName, id] = event.target.value.split('|');

        if (section === 1) setCategoryName1(selectedName);
        if (section === 2) setCategoryName2(selectedName);
        if (section === 3) setCategoryName3(selectedName);
        if (section === 4) setCategoryName4(selectedName);
        if (section === 5) setCategoryName5(selectedName);
        if (section === 6) setCategoryName6(selectedName);
        if (section === 7) setCategoryName7(selectedName);

        try {
            await axios.put(`${baseUrl}/api/extra-section/${extraSectionInfo._id}`, {
                [`name${section}`]: selectedName, [`id${section}`]: id,
            });
        } catch (error) {
            console.error("Error updating category name:", error);
        }
    };

    const handleCheckboxChange = async (event, field) => {
        const { checked } = event.target;
        try {
            await axios.put(`${baseUrl}/api/extra-section/${extraSectionInfo._id}`, {
                [field]: checked,
            });
            setExtraSectionInfo(prevState => ({
                ...prevState,
                [field]: checked,
            }));
        } catch (error) {
            console.error(`Error updating ${field}:`, error);
        }
    };

    if (!extraSectionInfo) return <div>Loading...</div>;

    return (
        <div className="space-y-6">
            {/* Extra Section 1 */}
            <div className="p-4 bg-white shadow rounded-lg">
                <h3 className="text-lg font-semibold">Extra Section 1</h3>
                <div className="space-y-2">
                    {/* Category Type */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="categoryType1" className="text-gray-700 font-medium italic">
                        </label>
                        <select
                            name="categoryType1"
                            id="categoryType1"
                            onChange={(e) => handleCategoryTypeChange(e, 1)}
                            className="border border-gray-300 rounded-md p-2"
                            value={categoryType1}
                        >
                            <option value="">update Type</option>
                            <option value="Category">Category</option>
                            <option value="Subcategory">Subcategory</option>
                        </select>
                    </div>


                    <div className="flex flex-col space-y-2">
                        <label htmlFor="categoryName1" className="text-gray-700 font-medium italic">
                        </label>
                        <select
                            name="categoryName1"
                            id="categoryName1"
                            onChange={(e) => handleCategoryNameChange(e, 1)}
                            className="border border-gray-300 rounded-md p-2"
                            value={categoryName1}
                        >
                            <option value="">Update {categoryType1 === "Category" ? "Category" : "Subcategory"} Name</option>
                            {(categoryType1 === "Category" ? categories : subcategories).map(item => (
                                <option key={item._id} value={`${item.name}|${item._id}`}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <h3 className="font-semibold text-red-400 ml-3 py-2">Current: <span className='text-green-500'>{categoryName1}</span></h3>


                    {/* Web & Mobile Toggle */}
                    <div className="flex items-center space-x-4">
                        <label htmlFor="sectionWeb1" className="flex items-center">
                            <input
                                type="checkbox"
                                id="sectionWeb1"
                                checked={extraSectionInfo.sectionWeb1}
                                onChange={(e) => handleCheckboxChange(e, 'sectionWeb1')}
                                className="mr-2 toggle toggle-primary"
                            />
                            Web View
                        </label>
                        <label htmlFor="sectionMobile1" className="flex items-center">
                            <input
                                type="checkbox"
                                id="sectionMobile1"
                                checked={extraSectionInfo.sectionMobile1}
                                onChange={(e) => handleCheckboxChange(e, 'sectionMobile1')}
                                className="mr-2 toggle toggle-primary"
                            />
                            Mobile View
                        </label>
                    </div>
                </div>
            </div>

            {/* Extra Section 2 */}
            <div className="p-4 bg-white shadow rounded-lg">
                <h3 className="text-lg font-semibold ">Extra Section 2</h3>
                <div className="space-y-2">
                    {/* Category Type */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="categoryType2" className="text-gray-700 font-medium italic">
                        </label>
                        <select
                            name="categoryType2"
                            id="categoryType2"
                            onChange={(e) => handleCategoryTypeChange(e, 2)}
                            className="border border-gray-300 rounded-md p-2"
                            value={categoryType2}
                        >
                            <option value="">update Type</option>
                            <option value="Category">Category</option>
                            <option value="Subcategory">Subcategory</option>
                        </select>
                    </div>

                    {/* Category Name */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="categoryName2" className="text-gray-700 font-medium italic">
                        </label>
                        <select
                            name="categoryName2"
                            id="categoryName2"
                            onChange={(e) => handleCategoryNameChange(e, 2)}
                            className="border border-gray-300 rounded-md p-2"
                            value={categoryName2}
                        >
                            <option value="">update {categoryType2 === "Category" ? "Category" : "Subcategory"} Name</option>
                            {(categoryType2 === "Category" ? categories : subcategories).map(item => (
                                <option key={item._id} value={`${item.name}|${item._id}`}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <h3 className="font-semibold text-red-400 ml-3 py-2">Current: <span className='text-green-500'>{categoryName2}</span></h3>


                    {/* Web & Mobile Toggle */}
                    <div className="flex items-center space-x-4">
                        <label htmlFor="sectionWeb2" className="flex items-center">
                            <input
                                type="checkbox"
                                id="sectionWeb2"
                                checked={extraSectionInfo.sectionWeb2}
                                onChange={(e) => handleCheckboxChange(e, 'sectionWeb2')}
                                className="mr-2 toggle toggle-primary"
                            />
                            Web View
                        </label>
                        <label htmlFor="sectionMobile2" className="flex items-center">
                            <input
                                type="checkbox"
                                id="sectionMobile2"
                                checked={extraSectionInfo.sectionMobile2}
                                onChange={(e) => handleCheckboxChange(e, 'sectionMobile2')}
                                className="mr-2 toggle toggle-primary"
                            />
                            Mobile View
                        </label>
                    </div>
                </div>
            </div>

            {/* Extra Section 3 */}
            <div className="p-4 bg-white shadow rounded-lg">
                <h3 className="text-lg font-semibold">Extra Section 3</h3>
                <div className="space-y-2">
                    {/* Category Type */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="categoryType3" className="text-gray-700 font-medium italic">
                        </label>
                        <select
                            name="categoryType3"
                            id="categoryType3"
                            onChange={(e) => handleCategoryTypeChange(e, 3)}
                            className="border border-gray-300 rounded-md p-2"
                            value={categoryType3}
                        >
                            <option value="">update Type</option>
                            <option value="Category">Category</option>
                            <option value="Subcategory">Subcategory</option>
                        </select>
                    </div>

                    {/* Category Name */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="categoryName3" className="text-gray-700 font-medium italic">
                        </label>
                        <select
                            name="categoryName3"
                            id="categoryName3"
                            onChange={(e) => handleCategoryNameChange(e, 3)}
                            className="border border-gray-300 rounded-md p-2"
                            value={categoryName3}
                        >
                            <option value="">update {categoryType3 === "Category" ? "Category" : "Subcategory"} Name</option>
                            {(categoryType3 === "Category" ? categories : subcategories).map(item => (
                                <option key={item._id} value={`${item.name}|${item._id}`}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <h3 className="font-semibold text-red-400 ml-3 py-2">Current: <span className='text-green-500'>{categoryName3}</span></h3>


                    {/* Web & Mobile Toggle */}
                    <div className="flex items-center space-x-4">
                        <label htmlFor="sectionWeb3" className="flex items-center">
                            <input
                                type="checkbox"
                                id="sectionWeb3"
                                checked={extraSectionInfo.sectionWeb3}
                                onChange={(e) => handleCheckboxChange(e, 'sectionWeb3')}
                                className="mr-2 toggle toggle-primary"
                            />
                            Web View
                        </label>
                        <label htmlFor="sectionMobile3" className="flex items-center">
                            <input
                                type="checkbox"
                                id="sectionMobile3"
                                checked={extraSectionInfo.sectionMobile3}
                                onChange={(e) => handleCheckboxChange(e, 'sectionMobile3')}
                                className="mr-2 toggle toggle-primary"
                            />
                            Mobile View
                        </label>
                    </div>
                </div>
            </div>

            {/* Extra Section 4 */}
            <div className="p-4 bg-white shadow rounded-lg">
                <h3 className="text-lg font-semibold">APP Extra Section 4</h3>
                <div className="space-y-2">
                    {/* Category Type */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="categoryType4" className="text-gray-700 font-medium italic">
                        </label>
                        <select
                            name="categoryType4"
                            id="categoryType4"
                            onChange={(e) => handleCategoryTypeChange(e, 4)}
                            className="border border-gray-300 rounded-md p-2"
                            value={categoryType4}
                        >
                            <option value="">update Type</option>
                            <option value="Category">Category</option>
                            <option value="Subcategory">Subcategory</option>
                        </select>
                    </div>

                    {/* Category Name */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="categoryName4" className="text-gray-700 font-medium italic">
                        </label>
                        <select
                            name="categoryName4"
                            id="categoryName4"
                            onChange={(e) => handleCategoryNameChange(e, 4)}
                            className="border border-gray-300 rounded-md p-2"
                            value={categoryName4}
                        >
                            <option value="">update {categoryType4 === "Category" ? "Category" : "Subcategory"} Name</option>
                            {(categoryType4 === "Category" ? categories : subcategories).map(item => (
                                <option key={item._id} value={`${item.name}|${item._id}`}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <h3 className="font-semibold text-red-400 ml-3 py-2">Current: <span className='text-green-500'>{categoryName4}</span></h3>


                    {/* Web & Mobile Toggle */}
                    {/* <div className="flex items-center space-x-4">
                        <label htmlFor="sectionWeb4" className="flex items-center">
                            <input
                                type="checkbox"
                                id="sectionWeb4"
                                checked={extraSectionInfo.sectionWeb4}
                                onChange={(e) => handleCheckboxChange(e, 'sectionWeb4')}
                                className="mr-2 toggle toggle-primary"
                            />
                            Web View
                        </label>
                        <label htmlFor="sectionMobile4" className="flex items-center">
                            <input
                                type="checkbox"
                                id="sectionMobile4"
                                checked={extraSectionInfo.sectionMobile4}
                                onChange={(e) => handleCheckboxChange(e, 'sectionMobile4')}
                                className="mr-2 toggle toggle-primary"
                            />
                            Mobile View
                        </label>
                    </div> */}
                </div>
            </div>


            {/* Extra Section 5 */}
            <div className="p-4 bg-white shadow rounded-lg">
                <h3 className="text-lg font-semibold">APP Extra Section 5</h3>
                <div className="space-y-2">
                    {/* Category Type */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="categoryType5" className="text-gray-700 font-medium italic">
                        </label>
                        <select
                            name="categoryType5"
                            id="categoryType5"
                            onChange={(e) => handleCategoryTypeChange(e, 5)}
                            className="border border-gray-300 rounded-md p-2"
                            value={categoryType5}
                        >
                            <option value="">update Type</option>
                            <option value="Category">Category</option>
                            <option value="Subcategory">Subcategory</option>
                        </select>
                    </div>

                    {/* Category Name */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="categoryName5" className="text-gray-700 font-medium italic">
                        </label>
                        <select
                            name="categoryName5"
                            id="categoryName5"
                            onChange={(e) => handleCategoryNameChange(e, 5)}
                            className="border border-gray-300 rounded-md p-2"
                            value={categoryName5}
                        >
                            <option value="">update {categoryType5 === "Category" ? "Category" : "Subcategory"} Name</option>
                            {(categoryType5 === "Category" ? categories : subcategories).map(item => (
                                <option key={item._id} value={`${item.name}|${item._id}`}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <h3 className="font-semibold text-red-400 ml-3 py-2">Current: <span className='text-green-500'>{categoryName5}</span></h3>


                    {/* Web & Mobile Toggle */}
                    {/* <div className="flex items-center space-x-4">
                        <label htmlFor="sectionWeb5" className="flex items-center">
                            <input
                                type="checkbox"
                                id="sectionWeb5"
                                checked={extraSectionInfo.sectionWeb5}
                                onChange={(e) => handleCheckboxChange(e, 'sectionWeb5')}
                                className="mr-2 toggle toggle-primary"
                            />
                            Web View
                        </label>
                        <label htmlFor="sectionMobile5" className="flex items-center">
                            <input
                                type="checkbox"
                                id="sectionMobile5"
                                checked={extraSectionInfo.sectionMobile5}
                                onChange={(e) => handleCheckboxChange(e, 'sectionMobile5')}
                                className="mr-2 toggle toggle-primary"
                            />
                            Mobile View
                        </label>
                    </div> */}
                </div>
            </div>

            {/* Extra Section 6 */}
            <div className="p-4 bg-white shadow rounded-lg">
                <h3 className="text-lg font-semibold">APP Extra Section 6</h3>
                <div className="space-y-2">
                    {/* Category Type */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="categoryType6" className="text-gray-700 font-medium italic">
                        </label>
                        <select
                            name="categoryType6"
                            id="categoryType6"
                            onChange={(e) => handleCategoryTypeChange(e, 6)}
                            className="border border-gray-300 rounded-md p-2"
                            value={categoryType6}
                        >
                            <option value="">update Type</option>
                            <option value="Category">Category</option>
                            <option value="Subcategory">Subcategory</option>
                        </select>
                    </div>

                    {/* Category Name */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="categoryName6" className="text-gray-700 font-medium italic">
                        </label>
                        <select
                            name="categoryName6"
                            id="categoryName6"
                            onChange={(e) => handleCategoryNameChange(e, 6)}
                            className="border border-gray-300 rounded-md p-2"
                            value={categoryName6}
                        >
                            <option value="">update {categoryType6 === "Category" ? "Category" : "Subcategory"} Name</option>
                            {(categoryType6 === "Category" ? categories : subcategories).map(item => (
                                <option key={item._id} value={`${item.name}|${item._id}`}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <h3 className="font-semibold text-red-400 ml-3 py-2">Current: <span className='text-green-500'>{categoryName6}</span></h3>


                    {/* Web & Mobile Toggle */}
                    {/* <div className="flex items-center space-x-4">
                        <label htmlFor="sectionWeb6" className="flex items-center">
                            <input
                                type="checkbox"
                                id="sectionWeb6"
                                checked={extraSectionInfo.sectionWeb6}
                                onChange={(e) => handleCheckboxChange(e, 'sectionWeb6')}
                                className="mr-2 toggle toggle-primary"
                            />
                            Web View
                        </label>
                        <label htmlFor="sectionMobile6" className="flex items-center">
                            <input
                                type="checkbox"
                                id="sectionMobile6"
                                checked={extraSectionInfo.sectionMobile6}
                                onChange={(e) => handleCheckboxChange(e, 'sectionMobile6')}
                                className="mr-2 toggle toggle-primary"
                            />
                            Mobile View
                        </label>
                    </div> */}
                </div>
            </div>

            {/* Extra Section 7 */}
            <div className="p-4 bg-white shadow rounded-lg">
                <h3 className="text-lg font-semibold">APP Extra Section 7</h3>
                <div className="space-y-2">
                    {/* Category Type */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="categoryType7" className="text-gray-700 font-medium italic">
                        </label>
                        <select
                            name="categoryType7"
                            id="categoryType7"
                            onChange={(e) => handleCategoryTypeChange(e, 7)}
                            className="border border-gray-300 rounded-md p-2"
                            value={categoryType7}
                        >
                            <option value="">update Type</option>
                            <option value="Category">Category</option>
                            <option value="Subcategory">Subcategory</option>
                        </select>
                    </div>

                    {/* Category Name */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="categoryName7" className="text-gray-700 font-medium italic">
                        </label>
                        <select
                            name="categoryName7"
                            id="categoryName7"
                            onChange={(e) => handleCategoryNameChange(e, 7)}
                            className="border border-gray-300 rounded-md p-2"
                            value={categoryName7}
                        >
                            <option value="">update {categoryType7 === "Category" ? "Category" : "Subcategory"} Name</option>
                            {(categoryType7 === "Category" ? categories : subcategories).map(item => (
                                <option key={item._id} value={`${item.name}|${item._id}`}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <h3 className="font-semibold text-red-400 ml-3 py-2">Current: <span className='text-green-500'>{categoryName7}</span></h3>


                    {/* Web & Mobile Toggle */}
                    {/* <div className="flex items-center space-x-4">
                        <label htmlFor="sectionWeb7" className="flex items-center">
                            <input
                                type="checkbox"
                                id="sectionWeb7"
                                checked={extraSectionInfo.sectionWeb7}
                                onChange={(e) => handleCheckboxChange(e, 'sectionWeb7')}
                                className="mr-2 toggle toggle-primary"
                            />
                            Web View
                        </label>
                        <label htmlFor="sectionMobile7" className="flex items-center">
                            <input
                                type="checkbox"
                                id="sectionMobile7"
                                checked={extraSectionInfo.sectionMobile7}
                                onChange={(e) => handleCheckboxChange(e, 'sectionMobile7')}
                                className="mr-2 toggle toggle-primary"
                            />
                            Mobile View
                        </label>
                    </div> */}
                </div>
            </div>

        </div>
    );
}

export default ExtraSection;
